import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import CategoryPage from '../components/CategoryPage';
import VerticalPage from '../components/VerticalPage';
import { EXPERIMENTS, ALLOCATIONS } from '../../../shared/constants/experiments';
import { CategoryClientPropTypes } from '../types';

const CategoryClient = ({ category, id: categorySlug }) => {
    const { abTests } = getContext();
    const inNewVerticalTestPage = abTests[EXPERIMENTS.CAT_LISTINGS_NEW_VERTICAL_PAGE_TEST] === ALLOCATIONS.TEST_B;

    if (inNewVerticalTestPage) {
        return <VerticalPage/>;
    } else {
        return (
            <CategoryPage category={category} categorySlug={categorySlug}/>
        );
    }
};

CategoryClient.propTypes = CategoryClientPropTypes;

export default CategoryClient;
